<script>
  import {Tipos} from './Tipos'

  export default{
    name: 'email-item',
    props: ['mail'],
    data () {
      return {}
    },
    computed: {
      tipos () {
        return Tipos
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <li class="list-group-item clearfix b-l-3x" :style="{'border-left-color': mail.tipo && tipos[mail.tipo.id] && tipos[mail.tipo.id].color}">
    <!--<a class="avatar thumb pull-left m-r" href="#">
      <img src="../assets/user-default.png">
    </a>-->
    <div class="pull-right text-sm text-muted">
      <span class="hidden-xs ">{{ mail.data.date | moment }}</span>
      <!--i class="fa fa-paperclip m-l-sm"></i-->
    </div>
    <div class="clear">
      <div>
        <router-link :to="{ name:'view-email', params: { id: mail.id } }" class="text-md" :class="{ 'not-read': !mail.lido }" >{{ mail.assunto }} | <small>{{ mail.nome }}</small> <sup>#{{ mail.id }}</sup></router-link>
        <!--span class="label bg-light m-l-sm ">descobrir o que colocar aqui</span-->
      </div>
      <div class="text-ellipsis m-t-xs ">{{ mail.mensagem }}</div>
    </div>
  </li>
</template>

<style scoped>
  .not-read {
    font-weight: bolder !important;
  }
</style>



// WEBPACK FOOTER //
// EmailItem.vue?0fb40a52